import { render, staticRenderFns } from "./invalidCourse.vue?vue&type=template&id=b1f9e072&scoped=true&"
import script from "./invalidCourse.vue?vue&type=script&lang=js&"
export * from "./invalidCourse.vue?vue&type=script&lang=js&"
import style0 from "./invalidCourse.vue?vue&type=style&index=0&id=b1f9e072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f9e072",
  null
  
)

export default component.exports